export default __webpack_public_path__ + "static/media/icon_tick.2b3104cd.svg";